module.exports = __webpack_public_path__ + "img/1516019021.8d9937dd.jpg";